import type { RetellCallReport } from '../../types/callReport';

interface ViewCallReportModalProps {
  report: RetellCallReport;
  onClose: () => void;
}

export function ViewCallReportModal({ report, onClose }: ViewCallReportModalProps) {
  const labelClass = 'text-xs font-medium text-gray-500 uppercase tracking-wide';
  const valueClass = 'text-sm text-gray-900 mt-0.5';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white rounded-xl shadow-lg w-full max-w-lg mx-4 max-h-[90vh] flex flex-col">
        <div className="px-6 pt-6 pb-4 overflow-y-auto flex-1">
          <h2 className="text-lg font-bold text-gray-900 mb-4">View Call Report</h2>

          <div className="space-y-4">
            <div>
              <p className={labelClass}>Agent ID</p>
              <p className={valueClass}>{report.agentId}</p>
            </div>

            <div>
              <p className={labelClass}>Name</p>
              <p className={valueClass}>{report.name || '—'}</p>
            </div>

            <div>
              <p className={labelClass}>Score Categories</p>
              {report.scoreCategories.length === 0 ? (
                <p className="text-sm text-gray-400 mt-0.5">None</p>
              ) : (
                <div className="mt-1 space-y-3">
                  {report.scoreCategories.map((cat, i) => (
                    <div key={i} className="border border-gray-200 rounded-lg">
                      <div className="px-3 py-2 bg-gray-50 rounded-t-lg">
                        <p className="text-sm font-medium text-gray-800">{cat.title}</p>
                        <div className="flex gap-3 mt-0.5 text-xs text-gray-500">
                          <span>Weight: {cat.weight}</span>
                          <span>Order: {cat.order}</span>
                          {cat.highlighted && <span className="text-amber-600">Highlighted</span>}
                        </div>
                      </div>
                      {cat.criteria && cat.criteria.length > 0 && (
                        <div className="divide-y divide-gray-100">
                          {cat.criteria.map((crit, j) => (
                            <div key={j} className="px-3 py-2">
                              <p className="text-sm text-gray-700">{crit.text}</p>
                              <div className="flex gap-3 mt-0.5 text-xs text-gray-500">
                                <span>Key: {crit.key}</span>
                                <span>Type: {crit.type}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end px-6 py-4 border-t border-gray-100">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
